module.exports = __webpack_public_path__ + "static/media/Food_Obsessions.1d32e9db.png";